export default __webpack_public_path__ + "static/media/coupon-icon.46f5f4b1.jpg";